<template>
    <div>
        <div class="footer">
            <div class="w">
                <dl>
                    <dt>关于我们</dt>
                    <dd @click='$router.push({path:"about"})'>公司介绍</dd>
                    <dd @click='$router.push({path:"partner"})'>合作伙伴</dd>
                    <dd @click='$router.push({path:"support"})'>技术支持</dd>
                    <dd @click='$router.push({path:"about"})'>联系方式</dd>
                    <dd @click='$router.push({path:"join"})'>加入我们</dd>
                </dl>

                <dl>
                    <dt>产品系列</dt>
                    <dd><a href="/npm">网络流量分析平台</a></dd>
                    <dd><a href="/lingmou">灵眸智能运维平台</a></dd>
                    <dd><a href="/firewall">防火墙策略管理平台</a></dd>
                    <dd><a href="/linglong">灵珑应用交付管理平台</a></dd>
                </dl>

                <dl>
                    <dt>解决方案</dt>
                    <dd @click='$router.push({path:"user"})'>金融</dd>
                    <dd @click='$router.push({path:"user"})'>政府</dd>
                    <dd @click='$router.push({path:"user"})'>地产</dd>
                    <dd @click='$router.push({path:"user"})'>制造</dd>
                </dl>

                <dl>
                    <dt>用户中心</dt>
                    <dd @click='$router.push({path:"school"})'>在线培训</dd>
                    <dd>Demo试用</dd>
                    <!--
                    <a :href="timeStamp" download="">
                        <dd>产品白皮书</dd>
                    </a>
                    <dd>使用手册</dd> 
                    -->
                </dl>

                <dl class="fr stopdef">
                    <dt style="margin-bottom:12px;">全国咨询电话</dt>
                    <dd style="font-size:20px;color:#eee;margin-bottom:16px;">400 - 666 - 8216</dd>
                    <dd style="margin-bottom:0;">北京市朝阳区八里庄西里99</dd>
                    <dd style="margin-bottom:18px;">号住邦2000大厦2号楼807</dd>
                    <dd>
                        <img class="qrcode" src="../assets/img/qrcode.png" alt="">
                    </dd>
                </dl>
                <div class="copy_right">
                    <div class="left fl">.</div>
                    <div class="right fr">
                        Copyright © 2015-2022 北京智维盈讯网络科技有限公司
                        <a id="beian" href="https://beian.miit.gov.cn" target="_blank">京ICP备17016548号-2</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            download:'https://www.ncmps.com/api/download'
        }
    },
    computed:{
        timeStamp(){
            return this.download + '?v=' + new Date().getTime()
        }
    }

}
</script>

<style scoped lang='less'>
    .footer{
        width: 100%;
        height: 400px;
        padding-top: 80px;
        overflow: hidden;
        background: #211f35;
        color: #eee;
        dd:hover{
        color: #00FFFF;
        cursor: pointer;
        }
        #beian{
            color: rgba(238, 238, 238, 0.6);
        }
        #beian:hover{
            text-decoration: underline;
        }
        dl{
            float: left;
            margin-right: 164px;
            font-size: 12px;
        }
        dt{
            margin-bottom: 24px;
            font-size: 14px;
            font-weight: bold;
        }
        dd{
            margin-bottom: 24px;
            color:rgba(238,238,238,.6);
        }
        dl:nth-child(5){
            margin-right: 0;
        }
        dd a{
            color:rgba(238,238,238,.6);
        }
        dd a:hover{
            color:#00FFFF;
        }
        .qrcode{
            width: 90px;
            height: 90px;
        }
        .copy_right{
            width: 100%;
            float: left;
            font-size: 12px;
            color:rgba(238,238,238,.6);
            margin-top: 35px;
            vertical-align: bottom;

            .left{
                width: 26px;
                height: 26px;
                background: url('../assets/img/ncsmall.svg') no-repeat;
            }
        }
        .stopdef{
            pointer-events: none;
        }

    }

</style>